module.exports = __webpack_public_path__ + "static/media/ic_paid_well_yellow.e6cde8d3.svg";